module.exports = __webpack_public_path__ + "fonts/19caa75d15b3ff0a86348bdd5853de04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/phone.svg
// module id = 2005
// module chunks = 0